import {$height} from '@huzan/hz-utils'
import {getTokenForStorage, setTokenForStorage, removeTokenForStorage} from 'utils'
import createModel from 'utils/model'

export default createModel({
    namespace: 'base',
    state: {
        headerHeight: 60,
        winHeight: $height(window),
        accessToken: getTokenForStorage(),
    },

    effects: {},

    reducers: {
        immerSetOffset(state) {
            state.winHeight = $height(window)
        },
        immerSetAccessToken(state, action) {
            const {accessToken = ''} = action.payload
            setTokenForStorage(accessToken)

            state.accessToken = accessToken
        },
        immerRemoveAccessToken(state) {
            removeTokenForStorage()
            delete state.accessToken
        },
    },
})
